import React from 'react';
import PropTypes from 'prop-types';

import QuestionComment from 'components/QuestionComment/Loadable';

function QuestionComments({ label, comments, onResolveComment }) {
  if (!comments) {
    return null;
  }
  return comments.map(
    ({ text, isMandatory, resolved, commentId, isFetching }) => (
      <QuestionComment
        key={commentId}
        id={commentId}
        isFetching={isFetching}
        label={label}
        text={text}
        isMandatory={isMandatory}
        resolved={resolved}
        onResolveComment={onResolveComment}
        className="padding-left-md margin-top-xxs"
      />
    ),
  );
}

QuestionComments.propTypes = {
  label: PropTypes.string,
  comments: PropTypes.array,
  onResolveComment: PropTypes.func,
};

export default QuestionComments;
